"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
var immutable_1 = require("immutable");
var core_1 = __importStar(require("@gin-betting/core"));
var types_1 = require("./types");
var constants_1 = require("./constants");
var DELETE_MATCH_ID = core_1.default.entities.constants.DELETE_MATCH_ID;
exports.initialState = new types_1.FavoriteStateRecord();
function makeFavoritesReducer(state, action) {
    if (state === void 0) { state = exports.initialState; }
    switch (action.type) {
        case constants_1.REMOVE_FAVORITE_MATCH_REQUEST:
        case constants_1.GET_FAVORITE_EVENT_IDS_REQUEST: {
            return state.set('fetchStatus', core_1.App.FetchStatus.LOADING);
        }
        case constants_1.GET_FAVORITE_EVENT_IDS_SUCCESS:
        case constants_1.INIT_FAVORITE_LIST_LOCAL: {
            var data = action.payload.data;
            var favorite = data.favorite;
            if (!favorite)
                return state;
            var favoriteIds = immutable_1.OrderedSet(favorite);
            return state
                .set('fetchStatus', core_1.App.FetchStatus.LOADED)
                .set('favoriteIds', favoriteIds);
        }
        case constants_1.REMOVE_FAVORITE_MATCH_FAIL:
        case constants_1.ADD_FAVORITE_MATCH_FAIL:
        case constants_1.GET_FAVORITE_EVENT_IDS_FAIL: {
            return state.set('fetchStatus', core_1.App.FetchStatus.FAILED);
        }
        case constants_1.REMOVE_FAVORITE_MATCH_SUCCESS: {
            var favoriteId = action.payload.favoriteId;
            var stateFavoriteIds = state.get('favoriteIds');
            if (!favoriteId)
                return state;
            var newFavoriteIds = stateFavoriteIds.delete(favoriteId);
            return state.set('favoriteIds', newFavoriteIds);
        }
        case constants_1.ADD_FAVORITE_MATCH_SUCCESS: {
            var favoriteId = action.payload.favoriteId;
            if (favoriteId) {
                var stateFavoriteIds = state.get('favoriteIds');
                var newFavoriteIds = stateFavoriteIds.add(favoriteId);
                return state.set('favoriteIds', newFavoriteIds);
            }
            return state;
        }
        case constants_1.ADD_FAVORITE_MATCH_LOCAL: {
            var favoriteId = action.payload.favoriteId;
            var favoriteIds = state.get('favoriteIds');
            var newFavoriteIds = favoriteIds.add(favoriteId);
            return state.set('favoriteIds', newFavoriteIds);
        }
        case constants_1.REMOVE_FAVORITE_MATCH_LOCAL: {
            var favoriteId = action.payload.favoriteId;
            var favoriteIds = state.get('favoriteIds');
            var newFavoriteIds = favoriteIds.delete(favoriteId);
            return state.set('favoriteIds', newFavoriteIds);
        }
        case DELETE_MATCH_ID: {
            var matchId = action.payload.matchId;
            if (!matchId)
                return state;
            var favoriteIds = state.get('favoriteIds');
            var newFavoriteIds = favoriteIds.delete(matchId);
            return state.set('favoriteIds', newFavoriteIds);
        }
        default: {
            return state;
        }
    }
}
exports.default = makeFavoritesReducer;
//# sourceMappingURL=reducer.js.map